<template>
  <div>
    <ion-list-header>
      <ion-label>{{ $t("bookings.legal") }}</ion-label>
    </ion-list-header>
    <v-card>
      <div class="text-container" v-html="html"></div>
      <img class="signature-img" :src="signature" v-if="signature" />
      <p v-if="form" class="prop">
        {{ form.client.client_name }} ({{ form.client.client_id_doc }})
      </p>
      <p v-if="form" class="prop">{{ dates }}</p>
      <p v-if="form && form.price" class="prop">{{ form.price.price }}€</p>
      <div v-if="form && form.vehicles">
        <p v-for="vehicle of form.vehicles" :key="vehicle.id" class="prop">{{ $t("bookings.licensePlate") }}: {{ vehicle.license_plate }}</p>
      </div>
      <div class="sign-btn-container">
        <ion-button @click="signDialog = true">{{
          $t("bookings.sign")
        }}</ion-button>
      </div>
      <div>
        <ion-modal
          :is-open="signDialog"
          :swipe-to-close="true"
          :presenting-element="$parent.$refs.ionRouterOutlet"
        >
          <ion-page>
            <ion-header>
              <ion-toolbar>
                <ion-title>{{ $t("bookings.signature") }}</ion-title>
              </ion-toolbar>
            </ion-header>
            <ion-content style="text-align: center">
              <v-list-item three-line>
                <v-list-item-content>
                  <div style="padding-top: 26px; display: block">
                    {{ $t("bookings.signZoneHint") }}
                    <span class="signature-hint">{{
                      $t("bookings.signZoneHintColor")
                    }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <VueSignaturePad
                class="signature-zone"
                :options="{
                  onBegin: () => {
                    $refs.signaturePad.resizeCanvas();
                  },
                }"
                width="400px"
                height="300px"
                ref="signaturePad"
              />
              <ion-button @click="undo" color="light">{{
                $t("bookings.singatureDelete")
              }}</ion-button>
              <ion-button @click="save">{{
                $t("bookings.singatureSave")
              }}</ion-button>
            </ion-content>
          </ion-page>
        </ion-modal>
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import {
  IonInput,
  IonModal,
  IonPage,
  IonHeader,
  IonToolbar,
  IonButton,
} from "@ionic/vue";
import { defineComponent } from "vue";
import moment from "moment";

export default defineComponent({
  prop: ["value", "form"],
  props: {
    modelValue: {
      required: false,
      type: Object,
    },
    form: {
      required: true,
      type: Object,
    },
  },
  data: () => ({
    legalDialog: false,
    signDialog: false,
    html: null,
    signature: null,
  }),
  components: {
    IonModal,
    IonPage,
    IonHeader,
    IonToolbar,
    IonButton,
  },
  mounted() {
    if (this.value !== null) {
      this.signature = this.value;
    }
    this.getText();
  },
  watch: {
    "$i18n.locale": function (newVal, oldVal) {
      this.getText();
    },
  },
  methods: {
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      this.signDialog = false;
      if (isEmpty) {
        return;
      }
      this.legalDialog = false;
      this.$emit("valid", 9, true);
      this.$emit("continue");
      this.signature = data;
      this.$emit("update:modelValue", this.signature);
    },
    getText() {
      axios.get("/legal/" + (this.$i18n.locale == 'gb' ? 'en' : this.$i18n.locale)).then((resp) => {
        this.html = resp.data.html;
      });
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
  },
  computed: {
    dates() {
      return (
        moment(this.form.dates.start).format("DD/MM/YYYY HH:mm") +
        " al " +
        moment(this.form.dates.end).format("DD/MM/YYYY HH:mm")
      );
    },
  },
});
</script>

<style lang="scss" scoped>
.signature-img {
  width: 200px;
  margin: 0 auto;
  display: block;
  max-width: 95%;
}
.text-container {
  padding: 30px;
}
.sign-btn {
  margin: 16px auto 60px;
  display: block;
}
.signature-hint {
  background: #c4feff;
}
.signature-zone {
  background: #c4feff;
  margin: 30px auto;
}
.signature-container {
  text-align: center;
  button {
    margin: 16px auto;
  }
}
.sign-btn-container {
  text-align: center;
  margin: 0 0 40px 0;
}
.prop {
  margin: 0 30px;
}
</style>
